import type { HtmlType } from '../../types.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { LeafBlock } from '../leaf-block.js'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'

export const DividerBlockDirections = {
	horizontal: 'Horizontal',
	vertical: 'Vertical',
} as const
export type DividerBlockDirection = keyof typeof DividerBlockDirections

@jsonClass('DividerBlock')
export class DividerBlock extends LeafBlock {
	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'dropdown',
		order: 1,
		label: 'Direction',
		options: Object.entries(DividerBlockDirections),
	})
	direction: DividerBlockDirection = 'horizontal'

	producePreview(): HtmlType {
		return `<hr>`
	}

	getEditorCategory(): string {
		return 'Screen Structure'
	}
}
